import React from 'react';
import {FieldWithIcon} from "./FieldWithIcon";
import {VehicleDetails} from "../../../chatbotSlice";

interface Props {
    vehicle: VehicleDetails;
    headingRef: React.RefObject<HTMLHeadingElement>;
    derivativeRef: React.RefObject<HTMLParagraphElement>;
    headerHeight: number;
    derivativeHeight: number;
}

const formatPrice = (vehicle: VehicleDetails): string => {
    let price = vehicle.price;
    if (typeof price === 'number') {
        price = Number(price).toFixed(0);
    }
    if (price === undefined) {
        return "N/A";
    }
    if (price.includes("£")) {
        price = price.replace("£", "");
    }
    if (price.includes("+VAT")) {
        price = price.replace("+VAT", "");
    }
    return price;
}

export const VehicleInfoSection: React.FC<Props> = ({ vehicle, headingRef, derivativeRef, headerHeight, derivativeHeight }) => {
    return (
        <div className="p-3 w-full bg-white">
            <div>
                <div className="flex flex-row justify-between items-start gap-3">
                    <h4 className="font-bold text-left max-h-12 line-clamp-2" ref={headingRef} style={{minHeight: headerHeight}}>{vehicle.make ?? "No make"} {vehicle.model ?? "No model"}</h4>
                    <div className="flex flex-row items-center justify-end gap-1">
                        <p className="text-right whitespace-nowrap font-bold text-lg">{`£${formatPrice(vehicle)}`}</p>
                        <p className="text-right whitespace-nowrap font-bold text-sm text-gray-700">{vehicle.is_vat_included === false ? '+VAT' : ''}</p>
                    </div>
                </div>
                <p className="text-start text-sm font-normal max-h-10 line-clamp-2" ref={derivativeRef} style={{minHeight: derivativeHeight}}>{vehicle.derivative ?? "No derivative"}</p>
                <div className="flex flex-wrap items-center gap-x-4 pt-3">
                    {vehicle.year_of_manufacture && <FieldWithIcon imageUrl='/calendar.svg' fieldValue={vehicle.year_of_manufacture?.toString() ?? "N/A"}/>}
                    {vehicle.mileage && <FieldWithIcon imageUrl='/mileage.svg' fieldValue={(vehicle.mileage ?? "N/A ") + " miles"}/>}
                    {vehicle.fuel_type && <FieldWithIcon imageUrl='/fuel-type.svg' fieldValue={vehicle.fuel_type ?? "N/A"}/>}
                    {vehicle.transmission_type && <FieldWithIcon imageUrl='/gearbox.svg' fieldValue={vehicle.transmission_type ?? "N/A"}/>}
                </div>
            </div>
        </div>
    );
};
